import React from 'react';
import { withStyles, Typography, Icon, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ContentHeader from '../components/ContentHeader';
import globalStyles from '../styles';

const styles = theme => ({
    root: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px'
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    },
    button: {
        marginTop: 20
    },
    link: {
        ...globalStyles.link,
        fontWeight: 'bold'
    }
});

const TicketSmsSent = ({ classes }) => {
    const history = useHistory();
    return (
        <div className={classes.root}>
            <ContentHeader text="Ticket sent" id="ticket-sent-heading" />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    Your ticket was sent to the passenger.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    They can now access the ticket on their mobile device by
                    opening the private ticket link in the text message.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    The message should arrive instantly. If the passenger doesn
                    {"'"}t see it, send your message again and{' '}
                    <strong>double check the phone number</strong> is input
                    correctly.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    If your ticket still hasn{"'"}t arrived please contact our
                    support team via{' '}
                    <a
                        className={classes.link}
                        href="mailto:support@shuttleid.uk"
                    >
                        support@shuttleid.uk
                    </a>
                    .
                </Typography>

                <Button
                    className={classes.button}
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        history.goBack();
                    }}
                >
                    <Icon className={classes.icon}>arrow_back</Icon>
                    Back to ticket
                </Button>
            </div>
        </div>
    );
};

export default withStyles(styles)(TicketSmsSent);
